import store from '@/store';

export default class BaseClient {
  constructor(path, opts = {}) {
    this.apiClient = opts.apiClient;
    this.$path = path || '';
    this.$formatter = opts.format || null;
  }

  request(type, path) {
    store.dispatch('session/updateTimeout', new Date());
    const { restClient } = this.apiClient;
    return (data, options = {}) => {
      const req = restClient[type];
      const url = `${options.path || this.path}${path ? `/${path}` : ''}`;
      return ['post', 'put'].includes(type) ? req(url, data, options) : req(url, {
        params: data || null,
        ...options,
      });
    };
  }

  format(response) {
    if (response.data && typeof this.$formatter === 'function' && response.data !== '{}') {
      return this.$formatter(response.data);
    }
    return response.data;
  }

  handleError(error) {
    return this.apiClient.handleError(error.response || error);
  }

  get path() {
    let path = this.$path.startsWith('/') ? this.$path : `/${this.$path}`;
    path = path.endsWith('/') ? path.slice(0, -1) : path;
    return path;
  }
}
